











































































































import { Component, Vue, Watch } from "vue-property-decorator";

import Events from "@/components/Layout/ManagerMenu/Events.vue";
import Inventory from "@/components/Layout/ManagerMenu/Inventory.vue";
import Customers from "@/components/Layout/ManagerMenu/Customers.vue";
import Settings from "@/components/Layout/ManagerMenu/Settings.vue";
import Venues from "@/components/Layout/ManagerMenu/Venues.vue";
import Partners from "@/components/Layout/ManagerMenu/Partners.vue";

@Component({
  components: {
    Events,
    Inventory,
    Customers,
    Settings,
    Venues,
    Partners
  }
})
export default class ManagerMenu extends Vue {
  private activeMenu: string | null = null;
  private venueRoutes: Array<string> = [
    "BookingVenues",
    "NewBookingVenue",
    "BookingVenueDetails",
    "VenueCalendar"
  ];
  private eventRoutes: Array<string> = [
    "BookingEvents",
    "NewBookingEvent",
    "BookingEventDetails",
    "UserEvents"
  ];
  private inventoryRoutes: Array<string> = [
    "BookingInventoryProduct",
    "NewBookingInventoryProduct",
    "BookingInventoryProductDetails"
  ];
  private customerRoutes: Array<string> = [
    "CustomersOverview",
    "NewCustomer",
    "CustomerData",
    "CustomerContacts",
    "NewCustomerContact",
    "CustomerContactDetails",
    "CustomerParticipants",
    "NewCustomerParticipant",
    "CustomerParticipantDetails"
  ];

  private mounted(): void {
    this.setActiveMenuByRoute(this.$route.path);
    this.setActiveMenuByRouteName(this.$route.name);
  }

  private logOut(): void {
    localStorage.removeItem("partnerId");
    localStorage.removeItem("partnerCode");
    window.location.replace("/login");
  }

  private setActiveMenuByRouteName(name: string | undefined | null): void {
    if (name) {
      if (this.venueRoutes.indexOf(name) > -1) {
        this.activeMenu = "venues";
      }
      if (this.eventRoutes.indexOf(name) > -1) {
        this.activeMenu = "events";
      }
      if (this.customerRoutes.indexOf(name) > -1) {
        this.activeMenu = "customers";
      }
      if (this.inventoryRoutes.indexOf(name) > -1) {
        this.activeMenu = "inventory";
      }
    }
  }

  private setActiveMenuByRoute(route: string): void {
    if (route.indexOf("/settings") > -1) {
      this.activeMenu = "settings";
    }
  }

  @Watch("$route.path")
  route_path_changed(newState: string): void {
    this.setActiveMenuByRoute(newState);
  }

  @Watch("$route.name")
  route_name_changed(newState: string): void {
    this.setActiveMenuByRouteName(newState);
  }
}
